export default {
  SET_ENTERPRISE_KIND(state, data) {
    state.enterpriseKind = data;
  },
};
